(function(){"use strict";try{if(typeof document!="undefined"){var e=document.createElement("style");e.appendChild(document.createTextNode("" +
    ".v-dropdown-trigger{display:inline-block}.v-dropdown-trigger.v-dropdown-trigger--full-width{display:block}.v-dropdown-container{-webkit-font-smoothing:subpixel-antialiased;-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;backface-visibility:hidden;display:inline-block;margin:0;padding:0;position:absolute;top:0;left:0;border:1px solid #D6D7D7;box-sizing:border-box;background-color:#fff;border-radius:.3rem;overflow:hidden;z-index:3000;will-change:opacity,transform,top,left;-webkit-box-shadow:0 15px 25px rgba(0,0,0,.2);-moz-box-shadow:0 15px 25px rgba(0,0,0,.2);box-shadow:0 15px 25px #0003}.v-dropdown-container.v-dropdown-no-border{border:0;-webkit-box-shadow:0 3px 20px rgba(0,0,0,.2);-moz-box-shadow:0 3px 20px rgba(0,0,0,.2);box-shadow:0 3px 20px #0003}.animate-down-enter-from,.animate-down-leave-to{transform:perspective(1px) translateY(-6px) translateZ(0);opacity:0}.animate-up-enter-from,.animate-up-leave-to{transform:perspective(1px) translateY(6px) translateZ(0);opacity:0}.animate-down-enter-active,.animate-up-enter-active{-webkit-transition:all .3s ease-out;transition:all .3s ease-out}.animate-down-leave-active,.animate-up-leave-active{-webkit-transition:all .2s ease-out;transition:all .2s ease-out}" +
    "")),document.head.appendChild(e)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
import { defineComponent as U, ref as y, reactive as P, watch as I, onMounted as R, onBeforeUnmount as X, onUnmounted as k, withDirectives as D, h as b, vShow as _, Transition as N } from "vue";
function V() {
  const e = window.pageXOffset !== void 0, t = (document.compatMode || "") === "CSS1Compat";
  return {
    x: e ? window.pageXOffset : t ? document.documentElement.scrollLeft : document.body.scrollLeft,
    y: e ? window.pageYOffset : t ? document.documentElement.scrollTop : document.body.scrollTop
  };
}
function W(e) {
  return window.getComputedStyle(e).display === "none";
}
function G(e) {
  if (W(e)) {
    e.style.visibility = "hidden", e.style.display = "inline-block";
    const t = e.getBoundingClientRect();
    return e.style.visibility = "visible", e.style.display = "none", t;
  }
  return e.getBoundingClientRect();
}
const L = "click", Y = "hover", j = "contextmenu", H = 150, x = 5;
function A(e, t) {
  return typeof e.animated == "string" ? e.animated : e.animated ? t.value ? "animate-up" : "animate-down" : "";
}
function B(e) {
  return {
    isTriggerByClick: e.trigger === L,
    isTriggerByHover: e.trigger === Y,
    isTriggerByContextmenu: e.trigger === j
  };
}
function $(e, t, c, d) {
  const { isTriggerByContextmenu: n } = B(e), o = window.pageYOffset, s = document.documentElement.clientHeight, f = n ? t : c.top + o;
  let i = n ? t : c.top + c.height + x + o, r = !1, u = !1, h = !1;
  return i + d.height > o + s && (r = !0), f - x - d.height < o && (u = !0), !u && r && (i = f - x - d.height, h = !0), { dropUp: h, top: i };
}
function K(e, t, c, d) {
  const { isTriggerByContextmenu: n } = B(e), o = window.pageXOffset, s = document.documentElement.clientWidth, f = n ? 0 : c.width, i = n ? t : c.left + o, r = i + f / 2 - d.width / 2, u = i + f - d.width;
  switch (e.align) {
    case "left":
      return i + d.width > o + s ? u : i;
    case "center":
      return r + d.width > o + s ? u : u < o ? i : r;
    case "right":
      return u < o ? i : u;
  }
}
function q(e) {
  const t = V();
  return {
    x: e.pageX || e.clientX + t.x,
    y: e.pageY || e.clientY + t.y
  };
}
function z(e) {
  return {
    "v-dropdown-container": !0,
    "v-dropdown-no-border": !e.border
  };
}
const J = U({
  name: "VDropdown",
  props: {
    /** alignment direction */
    align: { type: String, default: "left" },
    border: { type: Boolean, default: !0 },
    /**
     * toggle display / close dropdown container
     */
    toggle: { type: Boolean, default: !0 },
    /** manual show / close the dropdown */
    manual: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    /**
     * open / close dropdown animation
     *
     * {boolean}
     * - true: use default animation
     * - false: don't display animation
     * {string} customized animation class-name
     */
    animated: { type: [String, Boolean], default: !0 },
    /**
     * the width of dropdown container
     * min-width: 80
     */
    width: { type: Number, default: void 0 },
    /**
     * trigger container display type
     * - false: inline-block
     * - true: block
     */
    fullWidth: { type: Boolean, default: !1 },
    /**
     * dropdown trigger method
     * - `click` default
     * - `hover`
     * - `contextmenu`
     */
    trigger: { type: String, default: L }
  },
  emits: ["visible-change"],
  setup(e, { slots: t, emit: c, expose: d }) {
    const n = y(!1), o = P({ top: "", left: "", width: "" }), s = P({ x: null, y: null }), f = y(!1), i = y(null), r = y(null), u = y(null), {
      isTriggerByClick: h,
      isTriggerByHover: T,
      isTriggerByContextmenu: C
    } = B(e);
    I(n, (l) => c("visible-change", l));
    function v() {
      e.disabled || ("trigger" in t && S(), T ? (window.clearTimeout(i.value), i.value = window.setTimeout(() => {
        n.value = !0;
      }, H)) : n.value = !0);
    }
    function p(l = !1) {
      e.disabled || !e.toggle && !l || (T ? (window.clearTimeout(i.value), i.value = window.setTimeout(() => {
        n.value = !1;
      }, H)) : n.value = !1);
    }
    function E() {
      n.value ? p() : v();
    }
    function S() {
      const l = G(r.value), a = G(u.value), w = $(e, s.y, l, a), g = K(e, s.x, l, a);
      f.value = w.dropUp, o.top = `${w.top}px`, o.left = `${g}px`;
    }
    function O(l) {
      if (!n.value)
        return;
      const a = l.composedPath().some((w) => w === r.value);
      a && !e.toggle && !C || (!a || a && C) && p(!0);
    }
    return R(() => {
      typeof e.width < "u" && (o.width = e.width + "px"), document.body.append(u.value), document.body.addEventListener("mousedown", O);
    }), X(() => {
      document.body.removeEventListener("mousedown", O), u.value && u.value.remove();
    }), k(() => {
      r.value && r.value.remove();
    }), d({
      display: v,
      close: p,
      toggleVisible: E,
      adjust: S,
      container: u,
      visible: n
    }), () => {
      const l = [];
      "trigger" in t && l.push(t.trigger({
        visible: n,
        disabled: e.disabled
      }));
      const a = {
        class: z(e),
        style: o,
        ref: u,
        // do not close dropdown container when
        // do some operations in that
        onMousedown: (m) => m.stopPropagation()
      };
      T && (a.onMouseenter = v, a.onMouseleave = p);
      const w = D(
        b("div", a, t.default && t.default()),
        [[_, n.value]]
      );
      l.push(
        b(N, { name: A(e, f) }, () => [w])
      );
      const g = {
        class: {
          "v-dropdown-trigger": !0,
          "v-dropdown-trigger--full-width": e.fullWidth
        },
        ref: r
      };
      return T ? (g.onMouseenter = v, g.onMouseleave = p) : h ? g.onClick = (m) => {
        e.manual || (m.stopPropagation(), E());
      } : C && (g.onContextmenu = (m) => {
        if (e.manual)
          return;
        m.stopPropagation(), m.preventDefault();
        const M = q(m);
        s.x = M.x, s.y = M.y, v();
      }), b("div", g, l);
    };
  }
});
export {
  J as Dropdown,
  J as default
};
